import {Circle, ClipPath, Defs, G, Mask, Path, Rect, Svg} from 'react-native-svg';

const EyeIcon = ({color = '#C7C7CC'}) => (
  <Svg width="18" height="18" viewBox="0 0 18 18" fill="none">
    <G clip-path="url(#clip0_74_2730)">
      <Mask id="path-1-inside-1_74_2730" fill="white">
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9 2.75C14.22 2.75 18 6.53 18 9C18 11.47 14.22 15.25 9 15.25C3.78 15.25 0 11.47 0 9C0 6.53 3.78 2.75 9 2.75ZM9 13C11.2091 13 13 11.2091 13 9C13 6.79086 11.2091 5 9 5C6.79086 5 5 6.79086 5 9C5 11.2091 6.79086 13 9 13Z"
        />
      </Mask>
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 2.75C14.22 2.75 18 6.53 18 9C18 11.47 14.22 15.25 9 15.25C3.78 15.25 0 11.47 0 9C0 6.53 3.78 2.75 9 2.75ZM9 13C11.2091 13 13 11.2091 13 9C13 6.79086 11.2091 5 9 5C6.79086 5 5 6.79086 5 9C5 11.2091 6.79086 13 9 13Z"
        fill={color}
      />
      <Path
        d="M19.5 9C19.5 7.09963 18.144 5.15039 16.3836 3.76876C14.5453 2.32603 11.9744 1.25 9 1.25V4.25C11.2456 4.25 13.1747 5.06397 14.5314 6.12874C15.966 7.25461 16.5 8.43037 16.5 9H19.5ZM9 16.75C11.9744 16.75 14.5453 15.674 16.3836 14.2312C18.144 12.8496 19.5 10.9004 19.5 9H16.5C16.5 9.56963 15.966 10.7454 14.5314 11.8713C13.1747 12.936 11.2456 13.75 9 13.75V16.75ZM-1.5 9C-1.5 10.9004 -0.144025 12.8496 1.61642 14.2312C3.45472 15.674 6.02564 16.75 9 16.75V13.75C6.75436 13.75 4.82528 12.936 3.46858 11.8713C2.03403 10.7454 1.5 9.56963 1.5 9H-1.5ZM9 1.25C6.02564 1.25 3.45472 2.32603 1.61642 3.76876C-0.144025 5.15039 -1.5 7.09963 -1.5 9H1.5C1.5 8.43037 2.03403 7.25461 3.46858 6.12874C4.82528 5.06397 6.75436 4.25 9 4.25V1.25ZM11.5 9C11.5 10.3807 10.3807 11.5 9 11.5V14.5C12.0376 14.5 14.5 12.0376 14.5 9H11.5ZM9 6.5C10.3807 6.5 11.5 7.61929 11.5 9H14.5C14.5 5.96243 12.0376 3.5 9 3.5V6.5ZM6.5 9C6.5 7.61929 7.61929 6.5 9 6.5V3.5C5.96243 3.5 3.5 5.96243 3.5 9H6.5ZM9 11.5C7.61929 11.5 6.5 10.3807 6.5 9H3.5C3.5 12.0376 5.96243 14.5 9 14.5V11.5Z"
        fill={color}
        mask="url(#path-1-inside-1_74_2730)"
      />
      <Circle cx="9" cy="9" r="2.5" fill={color} />
    </G>
    <Defs>
      <ClipPath id="clip0_74_2730">
        <Rect width="18" height="18" fill="white" />
      </ClipPath>
    </Defs>
  </Svg>
);

export default EyeIcon;
